export default {"src":"/_next/static/media/icon-close.5ae902de.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};